import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import { CheckCircle, DoneAll } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { currencySymbol, paymentMethodOptions } from "utils/constant";
import CustomTypography from "components/Fileds/CustomTypography";
import CustomSelect from "components/Fileds/CustomSelect";
import CustomButton from "components/Fileds/CustomButton";

const CollectOrderPayment = ({
  open,
  onClose,
  orderDetails,
  onCollectPayment,
  onCollectAndComplete,
  isCollecting = false,
  isCompleting = false,
  isLoading = false,
}) => {
  const vendorData = useSelector((state) => state?.posData?.vendor);
  const [paymentMode, setPaymentMode] = useState("cash");
  const theme = useTheme();
  const orderTotal = orderDetails?.total_amount || 0;

  const alreadyPaid = orderDetails?.paid_amount || 0;
  const totalAmount = orderDetails?.total_amount || 0;
  const remainingAmount = totalAmount - alreadyPaid;


  // const paymentMethodOptions = [
  //   {label: "Cash", value: "cash"},
  //   {label: "Credit/Debit Card", value: "card"},
  //   {label: "Mobile Wallet", value: "mobilewallet"},
  //   {label: "Gift Card/Voucher", value: "gift_card_voucher"},
  //   {label: "Loyalty Points", value: "loyalty_points"},
  // ]

  const isAnyActionLoading = Boolean(isCollecting || isCompleting || isLoading);

  return (
    <Dialog
      open={open}
      onClose={!isAnyActionLoading ? onClose : undefined}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "16px",
          backgroundColor: "#fff",
          width: "380px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "18px",
          textAlign: "center",
          fontWeight: 400,
          color: theme.palette.drawermenuitem.main,
          pb: 1,
        }}
      >
        Collecting Payment for order
        <CustomTypography
          component="div"
          label={`#${orderDetails?.order_id}`}
          sx={{ fontWeight: 600, fontSize: "18px", mt: 0.5, color: "#000" }}
        />
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", pt: 0, }}>
        <Box sx={{ my: 2 }}>
          {/* Total Amount */}
          <CustomTypography
            variant={"body1"}
            label={"Total Payable Amount"}
            sx={{ fontSize: "16px", fontWeight: 400, color: theme.palette.drawermenuitem.main, mb: 0.5 }}
          />

          <CustomTypography
            variant={"h6"}
            label={`${currencySymbol(vendorData?.currency)}${remainingAmount > 0 ? parseFloat(remainingAmount).toFixed(2) : parseFloat(totalAmount).toFixed(2)}`}
            sx={{ fontSize: "30px", fontWeight: 600, color: "#2E7D32", mb: 0 }}
          />
        </Box>

        <Divider />

        {/* Payment Mode */}
        <Box sx={{ mt: 3 }}>
          <CustomTypography
            variant={"body2"}
            sx={{ fontSize: "14px", fontWeight: 500, mb: 1, color: theme.palette.drawermenuitem.main }}
            label={"Select Payment Mode"}
          />
          <Box clssName='d-flex align-items-center jsutify-content-center' sx={{width:'100%'}}>
            <CustomSelect
              name="payment_method"
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
              options={paymentMethodOptions}
              formWidth={"60%"}
              textAlign={"left"}
              // sx={{textAlign:'left'}}
            />
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box className='d-flex align-items-center justify-content-center'
          sx={{
            gap: 2,
            mt: 4,
          }}
        >
          <CustomButton
            variant="outlined"
            onClick={isAnyActionLoading ? undefined : onClose}
            sx={{
              px: 3,
              fontSize: "14px",
              borderColor: "#000",
              color: "#000",
              backgroundColor: "#fff",
              borderRadius: '10px',
              height: '45px',
              cursor: isAnyActionLoading ? 'not-allowed' : 'pointer',
              pointerEvents: isAnyActionLoading ? 'none' : 'auto',
            }}
          >
            Cancel
          </CustomButton>

          <CustomButton
            sx={{
              width: '180px',
              borderRadius: '10px',
              height: '45px',
              cursor: isAnyActionLoading ? 'not-allowed' : 'pointer',
              pointerEvents: isAnyActionLoading ? 'none' : 'auto',
            }}
            onClick={isAnyActionLoading ? undefined : () => onCollectPayment(paymentMode)}
            loading={isCollecting || (isLoading && !isCompleting)}
          >
              Collect Payment
          </CustomButton>
        </Box>

        <CustomButton
            startIcon={<DoneAll />}
            onClick={isAnyActionLoading ? undefined : () => onCollectAndComplete(paymentMode)}
            loading={isCompleting}
            sx={{
              border: '1px solid #2E7D32',
              color: '#2E7D32',
              backgroundColor: '#fff',
              borderRadius: '10px',
              mt: 2,
              height: '45px',
              padding: '10px 25px',
              mb: 1,
              cursor: isAnyActionLoading ? 'not-allowed' : 'pointer',
              pointerEvents: isAnyActionLoading ? 'none' : 'auto',
            }}
        >
          Collect Payment & Complete Order
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

export default CollectOrderPayment;
